import api from '@pray/shared/utils/api';

export type GetProductMetricsSparklinesParams = {
  artistId: string;
  section: string;
  days?: number;
  referenceDate?: string | null;
  platform?: string | null;
  countryTier?: string | null;
  subStatus?: string | null;
  isRegistered?: string | null;
  bustCache?: boolean;
};

export const getProductMetricsSparklines = async ({
  artistId,
  section,
  days = 30,
  referenceDate = null,
  platform = null,
  countryTier = null,
  subStatus = null,
  isRegistered = null,
  bustCache = false,
}: GetProductMetricsSparklinesParams) => {
  const params: Record<string, string> = {
    sparklineDays: String(days),
  };

  if (referenceDate) params.referenceDate = referenceDate;
  if (platform && platform !== 'all') params.platform = platform;
  if (countryTier && countryTier !== 'all') params.countryTier = countryTier;
  if (subStatus && subStatus !== 'all') params.subStatus = subStatus;
  if (isRegistered && isRegistered !== 'all') params.isRegistered = isRegistered;
  if (bustCache) params.bustCache = 'true';

  const url = `/web/studio/artists/${artistId}/analytics/product-metrics/sparklines/${section}`;
  const response = await api.executeGetRequest(url, params);

  return (response.data as any)?.data?.data;
};
